import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  imagesContainer: {
    margin: 'auto',
    position: 'relative',
    paddingTop: '56.25%',
  },
  pdfImages: {
    objectFit: 'contain',
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
  },
  pdfModal: {},
  pdfCard: {
    width: '50vw',
    margin: 'auto',
  },
  prevNextButtons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.background.navbar,
  },
  pageNumberText: {
    margin: '10px 10px 0 5px ',
    fontWeight: 'bold',
    color: theme.palette.text.primary,
  },
  inputRoot: {
    color: theme.palette.text.primary,
    background: theme.palette.background.paper,
    borderRadius: '3px',
    width: '35px',
    zIndex: 99,
    marginLeft: 5,
    paddingLeft: 5,
    paddingRight: 5,
  },
  goInput: {
    display: 'flex',
    flexDirection: 'row',
  },
  inputInput: {
    transition: theme.transitions.create('width'),
    width: '50%',
    color: theme.palette.text.primary,
    fontSize: 14,

    [theme.breakpoints.up('sm')]: {
      width: '100%',
    },
  },
  paginationWrapper: {
    [theme.breakpoints.down('lg')]: {},
  },
}));

export default useStyles;
